import { ComponentCategory, ComponentType } from '../../types';

export default {
  name: ComponentType.FilePanel,
  title: 'File Panel',
  category: ComponentCategory.General,
};
